module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vbl-nav",
    class: {
      'is-vertical': _vm.vertical
    }
  }, [_c('ul', [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a80427b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vblNav/src/vblNav.vue
// module id = 263
// module chunks = 0